module.exports = __webpack_public_path__ + "img/slika4.c12c18a9.jpg";